import dayjs from "dayjs";
import { SchedulerProjectData } from "./../types/global";

export const setProjectsInRows = (projects: SchedulerProjectData[]): SchedulerProjectData[][] => {
  if (!Array.isArray(projects)) return [];

  // Separar projetos e não-projetos
  const nonProjectData = projects.filter((item) => !item.isProject);
  const projectData = projects.filter((item) => item.isProject);

  const rows: SchedulerProjectData[][] = [];

  // Alocar os projetos nas linhas primeiro
  for (const project of projectData) {
    let isAdded = false;
    for (const row of rows) {
      if (!row.some((p) => isColliding(p, project))) {
        row.push(project);
        isAdded = true;
        break;
      }
    }
    if (!isAdded) {
      rows.push([project]);
    }
  }

  // Adicionar os não-projetos em uma nova linha ao final
  if (nonProjectData.length) {
    rows.push(nonProjectData);
  }

  return rows;
};

// Função auxiliar para verificar colisões de datas entre projetos
const isColliding = (a: SchedulerProjectData, b: SchedulerProjectData): boolean => {
  return (
    dayjs(b.startDate).isBetween(a.startDate, a.endDate, null, "[]") ||
    dayjs(b.endDate).isBetween(a.startDate, a.endDate, null, "[]") ||
    (dayjs(b.startDate).isBefore(a.startDate, "day") && dayjs(b.endDate).isAfter(a.endDate, "day"))
  );
};
